import { render, staticRenderFns } from "./CommentsList.vue?vue&type=template&id=33caac70&scoped=true"
import script from "./CommentsList.vue?vue&type=script&lang=js"
export * from "./CommentsList.vue?vue&type=script&lang=js"
import style0 from "./CommentsList.vue?vue&type=style&index=0&id=33caac70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33caac70",
  null
  
)

export default component.exports